import React from 'react';
import { call, put } from 'redux-saga/effects';
import { takeLatest } from '../../../utils/reduxSaga';

import { actions as reduxActions } from '../reducers';
import { actions as sagaActions, GET_ACCOUNTS } from './types';
import { getData } from '../../../utils/http';
import { URLS } from '../../../consts/endpoints';
import { translate } from '../../../i18n/I18nProvider';
import Optional from '../../../utils/optional';
import orderBy from 'lodash.orderby';

export function getAccounts({ clientId }) {
  return {
    type: sagaActions[GET_ACCOUNTS],
    clientId
  };
}

export function* fetchAccounts({ clientId }) {
  let accounts = [],
    selectOptions = [],
    selectedAccount = {};

  try {
    const data = yield call(
      getData,
      `${URLS.QUOTE_CLIENTS}/${clientId}/accounts`
    );

    accounts = data;
    selectOptions = yield call(createSelectOptions, data);

    selectedAccount = Optional(selectOptions[0]).or({});
  } catch (e) {
    // handle error
  }

  yield put(reduxActions.setAccounts(accounts, selectOptions, selectedAccount));
}

function* watchGetAccounts() {
  yield takeLatest(sagaActions[GET_ACCOUNTS], fetchAccounts);
}

export default watchGetAccounts();

function createSelectOptions(data = []) {
  const options = data.map(el => {
    const { id, name, accountNo, type } = el;
    return {
      value: id,
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginLeft: '5px' }}>{`${name} - ${accountNo}`}</div>
          {type === 'CUSTOMER' ? (
            <i className="fas fa-handshake-alt"></i>
          ) : (
            <i className="fal fa-money-bill-alt"></i>
          )}
        </div>
      ),
      shortLabel: `${name} - ${accountNo}`,
      ...el
    };
  });

  const customerAccounts = options.filter(el => el.type === 'CUSTOMER');
  const invoiceAccounts = options.filter(el => el.type === 'INVOICE');

  return [
    { value: 'ALL', label: translate('INVOICES.ALL_ACCOUNTS') },
    ...orderBy(customerAccounts, 'shortLabel'),
    ...orderBy(invoiceAccounts, 'shortLabel')
  ];
}
